module.exports = __webpack_public_path__ + "static/img/Tela de PDV.bd115a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de PDV.png
// module id = iur7
// module chunks = 0